import './App.css';
import TodoList from './TodoList';
function App() {
  return (
   <div class="all-container">
    
    <TodoList />

   </div>
  );
}

export default App;
